class Swipers {
  constructor(swiper, Modules) {
    this.selectors = {
      slides: '.swiper-wrapper',
      slide: '.swiper-slide',
    };

    this.swiper = swiper;
    this.swiperModules = Modules;
    this.slider = null;

    this.init();
  }

  getSetting(name) {
    return this.swiper.getAttribute(`data-swiper-${name}`);
  }

  init() {
    const { Swiper } = this.swiperModules;

    const slidesCount = this.swiper.querySelectorAll(
      this.selectors.slide,
    ).length;

    const args = {
      slidesPerView: 1.25,
      speed: 1000,
      spaceBetween: 24,
      watchSlidesProgress: true,
      loop: false,
      pagination: false,
      effect: 'slide',
      centeredSlides: false,
      breakpoints: {
        480: {
          slidesPerView: 1.75,
        },
        640: {
          slidesPerView: 2.25,
        },
        768: {
          slidesPerView: 2.75,
        },
        1024: {
          slidesPerView: 3.25,
        },
        1200: {
          slidesPerView: slidesCount > 4 ? 4.24 : 4,
        },
      },
    };

    if (this.getSetting('type') === 'posts') {
      const postsBreakpoints = {
        ...args.breakpoints,
        ...{
          1024: {
            slidesPerView: slidesCount > 3 ? 3.25 : 3,
          },
          1200: {
            slidesPerView: slidesCount > 3 ? 3.25 : 3,
          },
        },
      };
      args.breakpoints = postsBreakpoints;
    }

    this.slider = new Swiper(this.swiper, args);
  }
}

export default () => {
  const swipers = document.querySelectorAll('.swiper');

  if (swipers.length) {
    import('swiper').then(({ Swiper }) => {
      swipers.forEach((swiper) => new Swipers(swiper, { Swiper }));
    });
  }
};
